/**
 * Demo-booking URL — env-driven so we can swap from a simple mailto
 * fallback to a real Calendly / Cal.com / SavvyCal link with one env
 * change in production (no code redeploy needed beyond restarting the
 * frontend dev server, since CRA bakes env values at build time).
 *
 * Behaviour:
 *  - If REACT_APP_DEMO_BOOKING_URL is set (e.g. https://cal.com/arissai/demo),
 *    that URL is used verbatim and the button opens it in a new tab.
 *  - Otherwise we fall back to mailto:hello@arissai.com with a pre-filled
 *    subject + body so prospects can request a slot by email.
 */

const FALLBACK_MAILTO = (
  "mailto:hello@arissai.com" +
  "?subject=" + encodeURIComponent("ARISSAI demo request") +
  "&body=" + encodeURIComponent(
    "Hi ARISSAI team,\n\n" +
    "I would like to book a demo of the platform.\n\n" +
    "Company:\n" +
    "Sector (IT / Consulting / Finance / Healthcare / Other):\n" +
    "Team size:\n" +
    "Preferred date & time (with timezone):\n\n" +
    "Thanks!"
  )
);

export const DEMO_BOOKING_URL =
  process.env.REACT_APP_DEMO_BOOKING_URL || FALLBACK_MAILTO;

/** True when the link goes to a real booking page (Calendly etc.) — controls
 *  whether to open in a new tab, since mailto: shouldn't use target=_blank. */
export const DEMO_USES_EXTERNAL = !DEMO_BOOKING_URL.startsWith("mailto:");
